import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {}



// WEBPACK FOOTER //
// C:/Users/leoth/Desktop/Leo/Programming/Hackathons/Octocite/octocite/src/app/app.component.ts